module.exports = __webpack_public_path__ + "img/save_tip.4ec6a4ad.png";